import { render, staticRenderFns } from "./ThemeSwitchHorizontal.vue?vue&type=template&id=0736f6d5&scoped=true"
import script from "./ThemeSwitchHorizontal.vue?vue&type=script&lang=js"
export * from "./ThemeSwitchHorizontal.vue?vue&type=script&lang=js"
import style0 from "./ThemeSwitchHorizontal.vue?vue&type=style&index=0&id=0736f6d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0736f6d5",
  null
  
)

export default component.exports